import React from 'react';
import { FormControlLabel, FormControlLabelProps } from '@mui/material';

const FormControlLabelDense: React.FC<FormControlLabelProps> = ({
  sx,
  ...propsWithoutSx
}) => (
  <FormControlLabel
    {...propsWithoutSx}
    sx={{
      marginLeft: '-4px',
      '& > .MuiRadio-root': {
        padding: '4px',
      },
      '& > .MuiCheckbox-root': {
        padding: '4px',
      },
      ...sx,
    }}
  />
);

export default FormControlLabelDense;
